import { useEffect } from "react";

export const usePreventBodyScroll = ({ active }: { active: boolean }): null => {
  useEffect(() => {
    document.body.style.overflow = active ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [active]);

  return null;
};
